export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./helpFeatures.vue?vue&type=template&id=151d635a&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/helpFeatures.vue?vue&type=template&id=151d635a&
// module id = 516
// module chunks = 30